import 'css-chunksrc/client/common/breadcrumbs/styles.scss';export default {
  "breadcrumbs": "_breadcrumbs_19nof_1",
  "breadcrumb": "_breadcrumb_19nof_1",
  "clickable": "_clickable_19nof_18",
  "current": "_current_19nof_26",
  "icon": "_icon_19nof_30",
  "separator": "_separator_19nof_39"
};